import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import "../assets/style.css";
import "../assets/main.css";
import "../assets/Tailwind.css";
export const ServicesResponsive = () => {

    const arrowStyles = {
        position: "absolute",
        zIndex: "40",
        top: "calc(50% - 15px)",
        width: 30,
        height: 30,
        cursor: "pointer",
      };


  return (
    <div>
         <Carousel
    /* autoPlay */
    showStatus={false}
    showArrows
    className="color-fondo cursor-pointer"
    style={{ height: "20rem" }}
    infiniteLoop
    showThumbs={false}
    useKeyboardArrows
    stopOnHover
    swipeable
    dynamicHeight
    emulateTouch
    showIndicators={false}
    renderArrowPrev={(onClickHandler, hasPrev, label) =>
      hasPrev && (
        <button
          type="button"
          onClick={onClickHandler}
          title={label}
          style={{ ...arrowStyles, left: 15 }}
        >
          <KeyboardArrowLeft
            style={{ fontSize: "50px", color: "white" }}
          />
        </button>
      )
    }
    renderArrowNext={(onClickHandler, hasNext, label) =>
      hasNext && (
        <button
          type="button"
          onClick={onClickHandler}
          title={label}
          style={{ ...arrowStyles, right: 30 }}
        >
          <KeyboardArrowRight
            style={{ fontSize: "50px", color: "white" }}
          />
        </button>
      )
    }
  >

     <div>
          <img
            alt=""
           src="/ViveroLosAromos/IMG_2060.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>
     <div>
          <img
            alt=""
              src="./IMGWSP/primeraImagen.jpeg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>
     <div>
          <img
            alt=""
              src="./IMGWSP/segundaImagen.jpeg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>
     <div>
          <img
            alt=""
                src="./IMGWSP/terceraImagen.jpeg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>
        <div>
          <img
            alt=""
            src="/ViveroLosAromos/IMG_2060.jpg"
            style={{
              backgroundColor: 'black',
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>
        <div>
          <img
            alt=""
            src="./IMGWSP/segundaImagen.jpeg"
            style={{
              backgroundColor: 'black',
              width: "100%",
              verticalAlign: "top",
              objectFit: "none",
              border: 0,
              height: "30rem",
            }}
          />
        </div>
        <div>
          <img
            alt=""
            src="./IMGWSP/segundaImagen.jpeg"
            style={{
              backgroundColor: 'black',
              width: "100%",
              verticalAlign: "top",
              objectFit: "none",
              border: 0,
              height: "30rem",
            }}
          />
        </div>
        <div>
          <img
            alt=""
            src="fotoOlivoBuena.jpg"
            style={{
              backgroundColor: 'black',
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

  

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/Los Aromos_2025_0074.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>


        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/cuidadoAgua.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/Los Aromos_2025_0056.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/Los Aromos_2025_0063.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/ImagenHojiblanca.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/Los Aromos_2025_0036.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/Los Aromos_2025_0037.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/Los Aromos_2025_0038.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/Los Aromos_2025_0041.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/Los Aromos_2025_0043.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/CuidadoAgua2.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/Los Aromos_2025_0028.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/Los Aromos_2025_0022.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/imagenJardinVarietal.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/Los Aromos_2025_0011.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/otraentrada.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/Los Aromos_2025_0019.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2198.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2205.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2191.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2193.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2197.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2181.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2183.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2184.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2172.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2173.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2175.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2178.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2158.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2161.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2168.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2169.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2170.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2140.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2144.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2146.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2151.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2157.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2127.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2128.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2129.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2137.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2112.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2118.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2095.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2097.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2099.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2104.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2109.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2082.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2085.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2089.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2090.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2091.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2074.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2077.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2078.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2063.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2066.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2071.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2055.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2056.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2057.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2059.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

        <div>
          <img
            alt="Vivero Los Aromos"
            src="/ViveroLosAromos/IMG_2060.jpg"
            style={{
              width: "100%",
              verticalAlign: "top",
              objectFit: "cover",
              border: 0,
              height: "30rem",
            }}
          />
        </div>

      </Carousel>
  </div>
  )
}
